import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { key: "form", label: "Details", n: 1 },
  { key: "payment", label: "Payment", n: 2 },
  { key: "delivery", label: "Download", n: 3 },
];

export const StepIndicator = ({ current }) => {
  const idx = STEPS.findIndex((s) => s.key === current);
  return (
    <div className="lg:sticky lg:top-24">
      <ol className="flex lg:flex-col gap-2 lg:gap-0">
        {STEPS.map((s, i) => {
          const done = i < idx;
          const active = i === idx;
          return (
            <li
              key={s.key}
              data-testid={`step-${s.key}`}
              className="flex-1 lg:flex-none flex items-center gap-3 lg:py-4"
            >
              <div
                className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold border transition-colors duration-300 ${
                  active
                    ? "bg-[#60A5FA] border-[#60A5FA] text-white"
                    : done
                    ? "bg-[#1E40AF] border-[#1E40AF] text-white"
                    : "bg-white border-[#D0E2FF] text-[#94A3B8]"
                }`}
              >
                {done ? <Check className="w-4 h-4" /> : s.n}
              </div>
              <div className="hidden sm:block">
                <div
                  className={`text-sm font-semibold ${
                    active ? "text-[#0F172A]" : done ? "text-[#1E40AF]" : "text-[#94A3B8]"
                  }`}
                >
                  {s.label}
                </div>
              </div>
            </li>
          );
        })}
      </ol>

      <div className="hidden lg:block mt-8 rounded-xl border border-[#D0E2FF] bg-[#F8FAFC] p-5">
        <div className="text-xs font-semibold uppercase tracking-wider text-[#64748B] mb-2">
          What you get
        </div>
        <ul className="space-y-2 text-sm text-[#475569]">
          <li className="flex gap-2"><Check className="w-4 h-4 text-[#10B981] mt-0.5" /> Print-ready PDF statement</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-[#10B981] mt-0.5" /> Standard accounting layout</li>
          <li className="flex gap-2"><Check className="w-4 h-4 text-[#10B981] mt-0.5" /> 1 free revision after payment</li>
        </ul>
      </div>
    </div>
  );
};
